import { AutocompleteModule, DatepickerModule, PaginationMapsModule } from "maps-angular-components";
import { CommonModule, DatePipe, DecimalPipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {PaginationModule, TabsModule, TooltipModule} from "ngx-bootstrap";
import {
  ResultadoRegraDetalheComponent,
  ResultadoRegraInfoDialogComponent,
} from "./resultado-regra-detalhe/resultado-regra-detalhe";

import { CarteiraModule } from "../carteira/carteira.module";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import {MatMenuModule} from '@angular/material/menu';
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { MemoriaCalculoComponent } from "../memoria-calculo/memoria-calculo.component";
import { NgModule } from "@angular/core";
import { NgStringPipesModule } from "ngx-pipes";
import { ParametroFuncaoDetalheComponent } from "../memoria-calculo/parametro-funcao-detalhe/parametro-funcao-detalhe.component";
import { RegraModule } from "../regra/regra.module";
import { ResultadoRegraPesquisaComponent } from "./resultado-regra-pesquisa/resultado-regra-pesquisa.component";
import { ResultadoRegraTabComponent } from "./resultado-regra-tab/resultado-regra-tab.component";
import { SharedModule } from "../shared/shared.module";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import { CarteiraAutocompleteModule } from "../shared/components/carteira-autocomplete/carteira-autocomplete.module";

@NgModule({
  declarations: [
    ResultadoRegraTabComponent,
    ResultadoRegraPesquisaComponent,
    ResultadoRegraInfoDialogComponent,
    ResultadoRegraDetalheComponent,
    MemoriaCalculoComponent,
    ParametroFuncaoDetalheComponent,
  ],
    imports: [
        CommonModule,
        TabsModule,
        ReactiveFormsModule,
        CarteiraModule,
        MatRadioModule,
        RegraModule,
        SharedModule,
        DatepickerModule,
        MatSelectModule,
        MatDialogModule,
        MatTableModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        PaginationMapsModule,
        PaginationModule,
        FormsModule,
        NgStringPipesModule,
        AutocompleteModule,
        CarteiraAutocompleteModule,
        TooltipModule,
        MatSlideToggleModule,
    ],
  providers: [DatePipe, DecimalPipe],
  entryComponents: [ResultadoRegraInfoDialogComponent, MemoriaCalculoComponent],
})
export class ResultadoRegraModule {}
